import axios, { AxiosRequestConfig } from 'axios';
// eslint-disable-next-line import/no-unresolved
import { getSig4RequestInterceptor } from '@ks-cqc/ks-fe-sig4-interceptor/perf-fast';
import radar from '@/utils/useRadar';
import { debugConsole } from '@aio/utils';

export const SIG_PATH = [
  '/health/api/v1/consult/getDoctorPageList', // 精确匹配
  '/health/api/v1/consult/savePatientInfo', // 精确匹配
  '/health/api/v1/home/queryHotHealthVideo', // 精确匹配
  '/health/api/v1/hospital/summary', // 精确匹配
  '/health/api/v1/measure/querySurveyHealthVideo', // 精确匹配
  '/health/api/v1/order/latelyConsultingRecord', // 精确匹配
  '/health/api/v1/order/queryOrderByOrderId', // 精确匹配
  '/health/api/v1/order/queryOrderByUserIdAndStatus', // 精确匹配
  '/health/api/v1/vaccine/hospitals', // 精确匹配
  '/health/api/v1/vaccine/selector' // 精确匹配
];

export const sig4RequestInterceptor = getSig4RequestInterceptor({
  // 是否开启debug
  debug: process.env.NODE_ENV !== 'production',
  // 需要加签的接口路径（匹配方式支持startsWith和正则）
  includePaths: SIG_PATH,
  // 不需要加签的接口路径 (优先级>includePaths)
  excludePaths: [
    // 同includePaths
  ],
  // 项目信息
  projectInfo: {
    appKey: 'iPGaWf2zqP', // （必传）
    did: '', // 默认""
    uid: '', // 默认""
    oversea: false // 默认false
  },
  // 雷达实例（做日志上报）
  radar,
  // 日志采样率（0-1）
  sampling: 1 // 默认1
});

export const headerRequestInterceptor = (config: AxiosRequestConfig) => {
  const pathname = config.url?.split('?')[0] || '';
  const match = SIG_PATH.includes(pathname);
  if (match) {
    const { headers } = config;
    const newHeaders = { ...headers, 'health-platform-flag': 'H5' };
    debugConsole('[health-platform-flag] 添加 HEADER 的 pathname', pathname);
    return { ...config, headers: newHeaders };
  }
  return config;
};

// ！！！优先use（保证请求拦截器的执行时机靠最后，保证获取的config是最终的）
axios.interceptors.request.use(sig4RequestInterceptor);
axios.interceptors.request.use(headerRequestInterceptor);

export default axios;
